import React, { useMemo } from 'react'
import {
  Box,
  Text,
  Flex,
  useBreakpointValue,
  Container
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const MotionBox = motion(Box)

const Section = () => {
  const { t } = useTranslation()
  const isMobile = useBreakpointValue({ base: true, md: false })

  const items = useMemo(
    () => [
      {
        title: t('리플 하나에 집중한 전략형 자동매매'),
        desc: t(
          'XRPlay는 리플(XRP)에만 집중합니다.\n하나의 종목에 특화된 만큼 더 깊이 있는 전략과 안정적인 성과를 추구합니다.'
        ),
        src: '/videos/c.mp4'
      },
      {
        title: t('하루 안정적 수익, 알고리즘으로 만든다!'),
        desc: t(
          '손실을 줄이고 기회를 잡는 데 최적화된 구조.\n매일 조금씩, 꾸준한 수익을 위한 자동매매 전략을 경험해보세요.'
        ),
        src: '/videos/b.mp4'
      },
      {
        title: t('감정 없는 매매, 시스템은 냉정하다!'),
        desc: t(
          '불안, 조급함, 후회? 자동매매에는 없습니다.\n정해진 전략에 따라 일관되게 실행되는 시스템이 손실을 줄여줍니다.'
        ),
        src: '/videos/a.mp4'
      }
    ],
    [t]
  )

  return (
    <Box>
      <Container maxW="6xl">
        {items.map((item, idx) => {
          const isEven = idx % 2 === 1
          const direction = isMobile ? 'column' : isEven ? 'row-reverse' : 'row'

          return (
            <Flex
              key={idx}
              direction={direction}
              align="center"
              justify="space-between"
              gap={{ base: 8, md: 16 }}
              mb={{ base: 8, md: 12 }}
            >
              {/* 🔹 영상 */}
              <MotionBox
                as="video"
                src={item.src}
                autoPlay
                muted
                loop
                playsInline
                objectFit="cover"
                borderRadius="2xl"
                w={{ base: '100%', md: '50%' }}
                h="auto"
                aspectRatio="16/9"
                boxShadow="lg"
                _hover={{ transform: 'scale(1.01)', transition: '0.3s ease' }}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.2 }}
              />

              {/* 🔹 텍스트 */}
              <MotionBox
                w={{ base: '100%', md: '50%' }}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.2 + 0.1 }}
              >
                <Text
                  fontSize={{ base: 'xl', md: '2xl' }}
                  fontWeight="bold"
                  color="gray.900"
                  mb={3}
                  lineHeight="short"
                  letterSpacing="-0.5px"
                >
                  {item.title}
                </Text>
                <Text
                  fontSize="md"
                  color="gray.600"
                  whiteSpace="pre-line"
                  lineHeight="tall"
                >
                  {item.desc}
                </Text>
              </MotionBox>
            </Flex>
          )
        })}
      </Container>
    </Box>
  )
}

export default Section
